<template>
  <div
    style="position: relative;width: 100%;height: 100%;padding-top: 0;"
    infinite-scroll-throttle-delay="200"
    class="list-scroll"
    v-infinite-scroll="getList"
    :infinite-scroll-disabled="loadMore == 'nomore'"
    infinite-scroll-distance="10"
  >
    <div v-for="(item, index) in list" :key="index" class="list-cell">
      <div class="avatar">
        <a-avatar :size="36" :src="item.user_avatar ? item.user_avatar : require('../assets/person.png')" />
      </div>
      <div class="msg">
        <div class="header">
          <div
            @click="select(index)"
            class="flex-row"
            style="margin-right: auto;"
          >
            <div class="teacher">
              {{ item.user_name }}
            </div>

            <div class="time">
              {{ item.record_time }}
            </div>
            <!-- <div v-show="item.data.sync_parent" class="status">
              已同步
            </div> -->
          </div>

          <!-- <a-dropdown placement="bottomRight" :trigger="['click']">
            <a-menu slot="overlay" placement="bottom">
              <a-menu-item @click="handleEdit(item)" key="1"> 编辑</a-menu-item>
              <a-menu-item @click="handleDel(item.id)" key="2">
                删除
              </a-menu-item>
              <a-menu-item @click="handleExport(item)" key="3">
                导出</a-menu-item
              >
              <a-menu-item
                @click.stop="$router.push('/observe/addTask')"
                key="4"
              >
                评论</a-menu-item
              >
              <a-menu-item
                @click.stop="$router.push('/observe/addTask')"
                key="5"
              >
                加入成长册</a-menu-item
              >
            </a-menu>
            <a-icon type="ellipsis" />
          </a-dropdown> -->
        </div>
        <div v-if="item.task_name" class="task_name">
          {{ "任务：" + item.task_name }}
        </div>
        <div v-show="item.title" class="title">{{ item.title }}</div>
        <div @click="select(index)" class="content">
          {{ item.record_text }}
        </div>
        <div>
          <file-list :files="item.att"></file-list>
        </div>
      </div>
    </div>

    <a-empty
      style="margin-top: 60px;"
      v-if="list.length == 0 && loadMore == 'nomore'"
    ></a-empty>
    <a-spin v-else :spinning="loading">
      <div style="width: 100%;height: 60px;text-align: center;">
        {{ loading ? "加载中..." : "-没有更多了-" }}
      </div>
    </a-spin>
  </div>
</template>

<script>
import _ from "lodash";
import axios from "axios";
import { directorTestApi } from "../api/api-director";
import { mapState } from "vuex";
import qs from "qs";
import fileList from "./fileList.vue";

export default {
  data() {
    return {
      selectIndex: 0,
      showModal: false,
      currentObserve: null,
      selectAll: false,
      loadMore: "loadmore",
      list: [],
      form: {
        currentPage: 1,
        pageSize: 10,
        etime: "",
        name: "",
        pageSize: 10,
        type: "",
        stime: "",
        teacher_id: "",
        student_id: "",
        class_id: "",
      },
    };
  },
  props: {
    student_id: {
      type: String,
      default: "",
    },
    times:{
      type: Array,
      default: () => [],
    }
  },
  watch: {
    times(val) {
      console.log(val)
      if (val && val.length) {
        this.form.stime = val[0];
        this.form.etime = val[1];
      } else {
        this.form.stime = "";
        this.form.etime = "";
      }
      console.log(this.form)
    },
    value() {
      this.list = _.cloneDeep(this.value);
    },
    showModal() {
      if (!this.showModal) {
        this.$emit("close");
      }
    },
    student_id() {
      this.list = [];
      this.loadMore = "loadmore";
      this.form.currentPage = 1;
      this.form.student_id = this.student_id;
      this.getList();
    },
  },
  components: {
    fileList,
  },
  computed: {
    ...mapState(["userInfo", "currentClass"]),
    loading() {
      return this.loadMore == "loading";
    },
  },
  mounted() {
    this.form.class_id = this.currentClass.id;
    this.form.teacher_id = this.userInfo.id;
    this.form.student_id = this.student_id;
    this.getList();
  },
  methods: {
    reSearch() {
      this.list = [];
      this.loadMore = "loadmore";
      this.form.currentPage = 1;
      this.getList();
    },
    reSet() {
      this.form.stime = "";
      this.form.etime = "";
      this.reSearch()
    },
    changeDateJt(e) {
      console.log(e)
    },
    getList() {
      if (this.loadMore != "loadmore") {
        return;
      }
      this.loadMore = "loading";
      axios({
        url: directorTestApi.main + directorTestApi.getTeacherObserCircleList,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        data: qs.stringify({
          ...this.form,
          sid: this.$store.state.headers,
        }),
        method: "POST",
      })
        .then((res) => {
          if (res.data.result) {
            this.list = [...this.list, ...res.data.data];
            this.form.currentPage++;
            if (res.data.data.length < this.form.pageSize) {
              this.loadMore = "nomore";
            } else {
              this.loadMore = "loadmore";
            }
          } else {
            this.loadMore = "nomore";
          }
        })
        .catch(() => {
          this.loadMore = "nomore";
        });
    },
    getDetail(id, type) {
      this.$message.loading({
        content: "正在获取详情...",
        key: "loading",
      });
      axios({
        url:
          type == "record"
            ? directorTestApi.main + directorTestApi.getObserRecordDetail
            : directorTestApi.main + directorTestApi.getObserNotableDetail,
        method: "POST",
        data: qs.stringify({
          id,
          teacher_id: this.userInfo.id,
          school_id: this.userInfo.school_id || "",
        }),
      }).then((res) => {
        if (res.data.result) {
          this.$message.success({
            content: "加载成功",
            key: "loading",
            duration: 0.5,
          });
          this.currentObserve = res.data.data;
          this.showModal = true;
          this.currentObserve.type = type;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    select() {

    },
    handleDel(id) {
      this.$confirm({
        title: "提示",
        content: "确定删除吗？",
        okText: "确定",
        centered: true,
        cancelText: "取消",
        onOk: () => {
          axios({
            url: directorTestApi.main + directorTestApi.delObserAll,
            method: "POST",
            data: qs.stringify({
              id: id ? id : this.list[this.selectIndex].id,
              teacher_id: this.userInfo.id,
            }),
          }).then((res) => {
            if (res.data.result) {
              this.list.splice(this.selectIndex, 1);
              this.showModal = false;
              this.selectIndex = -1;
              this.currentObserve = null;
              this.$message.success("删除成功");
            } else {
              this.$message.error(res.data.message);
            }
          });
        },
        onCancel: () => {},
      });
    },
  },
};
</script>

<style lang="scss" scoped>

.split {
  height: 10px;
  background: #f1f1f1;
}

.task_name {
  border: 1px dashed #67b0dc;
  padding: 3px 5px;
  border-radius: 2px;
  width: fit-content;
  color: #67b0dc;
  font-size: 12px;
  margin-top: 6px;
}
.title {
  font-weight: bold;
  font-size: 14px;
  color: #67b0dc;
  line-height: 1;
}

.drawer-content {
  .head {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #eee;
    padding: 15px;
    .title {
      flex: 1;
      text-align: left;
      margin-left: 2px;
      font-size: 16px;
      font-family: "微软雅黑";
      font-weight: bold;
      //字体平滑
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }
  }

  .teacher {
    padding: 15px;
    border-bottom: 1px solid #ececec;
    .left {
      flex-direction: column;
      align-items: flex-start;
      font-size: 12px;
      color: #6a6a6a;
      margin-left: 10px;
      .name {
        font-size: 14px;
        font-weight: 600;
        color: #101010;
      }
    }
    .flex-row {
      justify-content: space-between;
      width: 100%;
      font-size: 12px;
    }
  }

  .content {
    padding: 15px 15px 0 15px;
  }
}
.list {
  padding: 0 15px;
  position: relative;
}
.list-cell {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  margin: 10px 0 30px 0;
  .avatar {
    width: 36px;
    height: 36px;
    margin-right: 10px;
  }
  .msg {
    flex: 1;
    display: flex;
    flex-direction: column;
    .header {
      display: flex;
      flex-direction: row;
      align-items: center;
      font-size: 14px;
      color: #101010;
      cursor: pointer;
      .teacher {
        font-weight: bold;
        font-size: 14px;
      }

      .students {
        font-weight: bold;
      }

      .action {
        margin: 0 6px;
      }

      .info {
        margin-left: 10px;
      }

      .time {
        margin: 0 10px;
      }

      .status {
        color: #519fd3;
      }
    }
    .title {
      margin-top: 10px;
      color: #333;
      font-size: 14px;
      border-bottom: 1px dotted #333;
      width: fit-content;
      line-height: 20px;
    }
    .content {
      color: #6a6a6a;
      cursor: pointer;
    }
  }
}

.file {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-top: 10px;
  .item {
    width: 20%;
    display: block;
    padding-bottom: 20%;
    background: #eee;
    overflow: hidden;
    border-radius: 5px;
    cursor: pointer;
  }
}

.form-table {
  border: 1px solid #dedede;
  margin: 15px;
  border-radius: 3px;
  .form-title {
    min-height: 40px;
    text-align: center;
    font-weight: bold;
    font-size: 13px;
    color: #101010;
    letter-spacing: 2px;
    width: 100%;
    line-height: 40px;
    margin: 0 auto;
    background: #f1f8Fd;
  }
  .line {
    border-top: 1px solid #dedede;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    box-sizing: border-box;
    font-size: 12px;
    .label {
      min-height: 30px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      width: 100px;
      color: #101010;
      font-weight: bold;
      padding: 5px;
    }
    .border-left {
      border-left: 1px solid #dedede;
    }
    .info {
      border-left: 1px solid #dedede;
      color: #444;
      flex: 1;
      padding: 5px;
      min-height: 28px;

      .content {
        padding: 0;
      }

      .file {
        padding: 0;

        .item {
          position: relative;
          margin-right: 10px;
          video {
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            object-fit: fill;
          }

          audio {
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            object-fit: contain;
          }
        }
      }
    }
  }
}

.form-type {
  width: 500px;
  position: relative;

  .look {
    height: 45px;
    //背景透明渐变
    background: linear-gradient(to top, #fff, #fff, transparent);
    bottom: 16px;
    left: 16px;
    right: 16px;
    position: absolute;
    z-index: 1;
    padding-top: 5px;
    text-align: center;
    line-height: 40px;
    color: #519fd3;
    cursor: pointer;
  }
  .line {
    .label {
      min-height: 40px;
      line-height: 40px;
    }
    .info {
      min-height: 40px;
      line-height: 40px;
    }
  }
}
</style>
